export default __webpack_public_path__ + "static/media/arrow_tooltip.341bac2b.svg";